var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',{attrs:{"vs-type":"flex","vs-justify":"center","vs-align":"center","vs-w":"12"}},[_vm._v("\n"+_vm._s(_vm._f("dateFormatLocalization")(_vm.params.data.due_date))+"\n"+_vm._s(_vm._f("timeFormatLocalization")(_vm.params.data.due_date))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }